import React, { useContext } from 'react';

export const scaleManagerContext = React.createContext<Phaser.Scale.ScaleManager | undefined>(undefined);

export const useScaleManagerContext = (): Phaser.Scale.ScaleManager => {
  const c = useContext(scaleManagerContext);
  if (!c) throw new Error('scaleManagerContext not presented');
  return c;
};
